import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeftArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 13,
	viewBox: "0 0 16 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.29973 0.69527C7.03938 0.43491 6.61728 0.43491 6.35693 0.69527L1.02353 6.0286C0.763265 6.28895 0.763265 6.71105 1.02353 6.9714L6.35693 12.3048C6.61728 12.5651 7.03938 12.5651 7.29973 12.3048C7.56009 12.0444 7.56009 11.6223 7.29973 11.3619L3.10446 7.16667H14.8283C15.1965 7.16667 15.495 6.86819 15.495 6.5C15.495 6.13181 15.1965 5.83334 14.8283 5.83334H3.10446L7.29973 1.63807C7.56009 1.37772 7.56009 0.955617 7.29973 0.69527Z",
		fill: "white"
	})
});
export { SvgLeftArrow as ReactComponent };
